import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const statementRegistryApi = createApi({
  reducerPath: 'statementRegistryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/StatementRegistry',
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ['StatementRegistry'],
  endpoints: (builder) => ({
    listStatements: builder.query({
      query: (data) => ({
        url: '/List',
        method: 'POST',
        body: data,
      }),
      providesTags: ['StatementRegistry'],
    }),
    getDutyEmployees: builder.query({
      query: () => ({
        url: '/Employees',
        method: 'GET',
      }),
    }),
    setDutyEmployee: builder.mutation({
      query: (data) => ({
        url: '/SetDutyEmployee',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['StatementRegistry'],
    }),
  }),
});

export const {
  useListStatementsQuery,
  useGetDutyEmployeesQuery,
  useSetDutyEmployeeMutation,
} = statementRegistryApi;
